import { setMinutes as setMinutesFns } from 'date-fns';

export default function setMinutes(date: Date, minutes: number): Date {
  return setMinutesFns(date, minutes);
}
